<div style="margin-bottom:10px !important;">
    <button class="btn btn-primary  btn-sm" (click)="dmsPushModal()" translate="dmsOpenDialogButtonText"
            [popover]="popDmsPushTemplate" placement="top" triggers="mouseenter:mouseleave"></button>
</div>
<ng-template #popDmsPushTemplate>
    <p [innerHTML]="'dmsPushTooltip' | translate" class="dmsPushTooltip"></p>
</ng-template>
